/* SEIM Collects Theme JS v3 */
(function(){
'use strict';
function $(s,c){return(c||document).querySelector(s)}
function $$(s,c){return[...(c||document).querySelectorAll(s)]}
function money(c){return'$'+(c/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,',')}

/* FADE UP */
var obs=new IntersectionObserver(function(e){
  e.forEach(function(x){if(x.isIntersecting)x.target.classList.add('visible')});
},{threshold:.08,rootMargin:'0px 0px -50px 0px'});
$$('.fade-up').forEach(function(el){obs.observe(el)});

/* HERO CARD TILT */
$$('.hero-poke-card').forEach(function(card){
  card.addEventListener('mousemove',function(e){
    var r=card.getBoundingClientRect();
    var x=((e.clientX-r.left)/r.width-.5)*16;
    var y=((e.clientY-r.top)/r.height-.5)*-16;
    card.style.transform=(card.dataset.base||'')+' rotateX('+y+'deg) rotateY('+x+'deg) scale(1.06)';
  });
  card.addEventListener('mouseleave',function(){card.style.transform='';});
});

/* SPOTLIGHT CARD TILT */
var sCard=$('.spot-card');
if(sCard){
  sCard.addEventListener('mousemove',function(e){
    var r=sCard.getBoundingClientRect();
    sCard.style.animation='none';
    sCard.style.transform='rotateY('+((e.clientX-r.left)/r.width-.5)*22+'deg) rotateX('+((e.clientY-r.top)/r.height-.5)*-22+'deg)';
  });
  sCard.addEventListener('mouseleave',function(){sCard.style.animation='';sCard.style.transform='';});
}

/* CART DRAWER */
var drawer=$('#cart-drawer');
var overlay=$('#cart-overlay');
var closeBtn=$('#cart-close');
var cartBody=$('#cart-body');
var cartFooter=$('#cart-footer');
var totalEl=$('#cart-total');

function openCart(){
  if(!drawer)return;
  drawer.classList.add('open');
  drawer.removeAttribute('aria-hidden');
  document.body.style.overflow='hidden';
  fetchCart();
}
function closeCart(){
  if(!drawer)return;
  drawer.classList.remove('open');
  drawer.setAttribute('aria-hidden','true');
  document.body.style.overflow='';
}

$$('.icon-btn[data-cart]').forEach(function(b){b.addEventListener('click',openCart)});
if(overlay)overlay.addEventListener('click',closeCart);
if(closeBtn)closeBtn.addEventListener('click',closeCart);
document.addEventListener('keydown',function(e){if(e.key==='Escape')closeCart()});

function fetchCart(){
  fetch('/cart.js').then(function(r){return r.json()}).then(function(c){renderDrawer(c);updateBubbles(c.item_count)}).catch(function(){});
}

function renderDrawer(cart){
  if(!cartBody)return;
  if(cart.item_count===0){
    cartBody.innerHTML='<div class="cart-empty"><div style="font-size:48px;margin-bottom:16px;">🃏</div><p>Your cart is empty</p><a href="/collections/all" class="btn-primary" style="margin-top:20px;display:inline-flex;">Browse Cards</a></div>';
    if(cartFooter)cartFooter.style.display='none';
    return;
  }
  var html=cart.items.map(function(item){
    var img=item.image?'<img class="cart-line-img" src="'+item.image+'" alt="">'
      :'<div class="cart-line-img-ph">🃏</div>';
    var variant=(item.variant_title&&item.variant_title!=='Default Title')
      ?'<div class="cart-line-variant">'+item.variant_title+'</div>':'';
    return'<div class="cart-line">'+img+'<div class="cart-line-info">'
      +'<a href="'+item.url+'" class="cart-line-title">'+item.product_title+'</a>'
      +variant
      +'<div class="cart-line-row">'
      +'<div class="qty-controls">'
      +'<button class="qty-btn" data-key="'+item.key+'" data-qty="'+(item.quantity-1)+'">−</button>'
      +'<span class="qty-num">'+item.quantity+'</span>'
      +'<button class="qty-btn" data-key="'+item.key+'" data-qty="'+(item.quantity+1)+'">+</button>'
      +'</div>'
      +'<button class="btn-danger" data-key="'+item.key+'" data-qty="0">✕ Remove</button>'
      +'<span class="cart-line-price">'+money(item.line_price)+'</span>'
      +'</div></div></div>';
  }).join('');
  cartBody.innerHTML=html;
  if(totalEl)totalEl.textContent=money(cart.total_price);
  if(cartFooter)cartFooter.style.display='block';
  $$('.qty-btn',cartBody).forEach(function(btn){
    btn.addEventListener('click',function(){changeQty(btn.dataset.key,parseInt(btn.dataset.qty))});
  });
  $$('.btn-danger',cartBody).forEach(function(btn){
    btn.addEventListener('click',function(){changeQty(btn.dataset.key,0)});
  });
}

function changeQty(key,qty){
  fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
    .then(function(r){return r.json()}).then(function(c){renderDrawer(c);updateBubbles(c.item_count)});
}

function updateBubbles(count){
  $$('.cart-bubble').forEach(function(b){b.textContent=count;b.style.display=count>0?'flex':'none'});
}

/* ADD TO CART */
document.addEventListener('click',function(e){
  var btn=e.target.closest('[data-atc]');
  if(!btn)return;
  e.preventDefault();
  var id=btn.dataset.atc;
  if(!id)return;
  var label=btn.textContent;
  btn.textContent='Adding…';
  btn.disabled=true;
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:id,quantity:1})})
    .then(function(r){return r.json()}).then(function(){
      btn.textContent='✓ Added!';
      setTimeout(function(){btn.textContent=label;btn.disabled=false;openCart();},700);
      fetchCart();
    }).catch(function(){btn.textContent='Error';btn.disabled=false});
});

/* MOBILE NAV */
var burger=$('.burger');
var navLinks=$('.header-nav');
if(burger&&navLinks){
  burger.addEventListener('click',function(){
    var open=navLinks.classList.toggle('nav-open');
    if(open){
      Object.assign(navLinks.style,{display:'flex',flexDirection:'column',
        position:'fixed',top:'66px',left:'0',right:'0',
        background:'rgba(247,246,240,0.98)',padding:'20px 32px',
        borderBottom:'1px solid rgba(0,0,0,0.09)',zIndex:'499',gap:'16px',
        boxShadow:'0 8px 24px rgba(0,0,0,0.08)'});
    }else{navLinks.style.cssText='';}
  });
}

/* GALLERY */
$$('.g-thumb').forEach(function(t){
  t.addEventListener('click',function(){
    var main=$('.gallery-main img');
    if(main&&t.dataset.src){
      main.src=t.dataset.src;
      $$('.g-thumb').forEach(function(x){x.classList.remove('active')});
      t.classList.add('active');
    }
  });
});

/* VARIANT SELECT */
var vSel=$('#variant-select');
var atcBtn=$('#main-atc');
if(vSel&&atcBtn){
  vSel.addEventListener('change',function(){
    atcBtn.dataset.atc=vSel.value;
    var opt=vSel.options[vSel.selectedIndex];
    var priceEl=$('#price');
    if(priceEl&&opt.dataset.price)priceEl.textContent='$'+(parseInt(opt.dataset.price)/100).toFixed(2);
  });
}

/* NEWSLETTER */
var nlForm=$('.nl-form');
if(nlForm){
  nlForm.addEventListener('submit',function(e){
    e.preventDefault();
    var btn=nlForm.querySelector('.nl-btn');
    btn.textContent='✓ Subscribed!';
    btn.style.background='#2e7d32';
    setTimeout(function(){btn.textContent='Subscribe';btn.style.background='';nlForm.reset();},3000);
  });
}

fetchCart();
})();
